import { User_SortField, User_Status, User_Role } from '@/graphql/codegen/generated/graphql';
import { ObjectKeysFromValues } from '@/types/utils';
import { UsersTableColumns, UsersRoles } from './users-table.types';

export const MAP_COLUMNS_To_User_SortField: Pick<Record<UsersTableColumns, User_SortField>, 'ID' | 'Email' | 'Role' | 'Status' | 'Last Login' | 'Username' | 'Name'> = {
  ID: User_SortField.Id,
  Role: User_SortField.Role,
  Status: User_SortField.Status,
  Email: User_SortField.Email,
  'Last Login': User_SortField.LastLogin,
  Username: User_SortField.UserName,
  Name: User_SortField.FullName,
};

export const MAP_User_SortField_To_COLUMNS: Record<keyof ObjectKeysFromValues<typeof MAP_COLUMNS_To_User_SortField>, keyof typeof MAP_COLUMNS_To_User_SortField> = {
  [User_SortField.Status]: 'Status',
  [User_SortField.Role]: 'Role',
  [User_SortField.Email]: 'Email',
  [User_SortField.Id]: 'ID',
  [User_SortField.LastLogin]: 'Last Login',
  [User_SortField.UserName]: 'Username',
  [User_SortField.FullName]: 'Name',
};

export const MAP_User_Status: Record<keyof ObjectKeysFromValues<typeof User_Status>, keyof typeof User_Status> = {
  [User_Status.Active]: 'Active',
  [User_Status.Inactive]: 'Inactive',
  [User_Status.Locked]: 'Locked',
};

export const MAP_COLUMNS_To_User_Roles: Record<UsersRoles, User_Role> = {
  'Grid Admin': User_Role.GridAdmin,
  'Group Manager': User_Role.GroupManager,
  Viewer: User_Role.Viewer,
};
export const MAP_User_Roles_To_Show: Record<keyof ObjectKeysFromValues<typeof MAP_COLUMNS_To_User_Roles>, keyof typeof MAP_COLUMNS_To_User_Roles> = {
  [User_Role.GridAdmin]: 'Grid Admin',
  [User_Role.GroupManager]: 'Group Manager',
  [User_Role.Viewer]: 'Viewer',
};
